import { Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import NoRecords from 'components/NoRecords';
import { useBasePath } from 'components/Providers';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
// import { capitalize } from 'lodash';
// import jsPDF from 'jspdf';

const SubstituteTableList = ({ coveragePeriods, periods }) => {
    const navigate = useNavigate();
    const basePath = useBasePath();

    const cellSx = {
        p: 0.4,
        minWidth: '150px',
        borderBottom: 'none'
    };

    const outerBoxSx = {
        display: 'flex',
        p: '5px',
        alignItems: 'center',
        height: "100%",
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '10px',
        backgroundColor: 'white'
    };

    const periodBoxSx = {
        backgroundColor: 'divider',
        p: '5px',
        width: '100%',
        height: "50px",
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const staffPeriodBox = {
        ...periodBoxSx,
        backgroundColor: 'none',
        height: '80px',
        gap: '5px'
    };

    const staffCellBoxSx = {
        ...periodBoxSx,
        justifyContent: 'center',
        flexDirection: 'row'
    };


    const getStatusChip = (sub) => {
        if (sub) return <Chip size='small' label={sub} color="success" />;
        return <Chip size='small' label="No Sub Assigned" color="error" />;
    };

    return (
        <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell sx={cellSx}>
                            <Box sx={outerBoxSx}>
                                <Box sx={staffCellBoxSx}>
                                    <Typography variant='body2' fontWeight="500">Staff Name</Typography>
                                </Box>
                            </Box>
                        </TableCell>
                        {periods?.map((period) => (
                            <TableCell key={period.id} align="center" sx={cellSx}>
                                <Box sx={outerBoxSx}>
                                    <Box sx={periodBoxSx}>
                                        <Typography variant='body2' fontWeight="500">{period.name}</Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {`${dayjs(period?.startTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(period?.endTime, 'HH:mm:ss').format('h:mm A')}`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {coveragePeriods?.length > 0 ? (
                    <TableBody>
                        {coveragePeriods?.map((staff, index) => (
                            <TableRow key={index}>
                                <TableCell sx={cellSx}>
                                    <Box sx={outerBoxSx}>
                                        <Box sx={staffPeriodBox}>
                                            <Typography variant="body2" fontWeight="600">
                                                {staff.lastName}, {staff.firstName}
                                            </Typography>
                                            <Typography variant="body2" >
                                                {staff.leaveType}
                                            </Typography>
                                            <Chip
                                                size='small'
                                                label="Add/Update Coverage"
                                                color='warning'
                                                clickable
                                                onClick={() => navigate(`${basePath}/${staff.personId}`)}
                                            />
                                        </Box>
                                    </Box>
                                </TableCell>

                                {/* Period columns */}
                                {periods?.map((period) => {
                                    const matchedPeriod = staff.periods?.find(p => p.id === period.id);

                                    return (
                                        <TableCell key={period.id} sx={cellSx}>
                                            <Box sx={outerBoxSx}>
                                                <Box sx={staffPeriodBox}>
                                                    {matchedPeriod ? (
                                                        <>
                                                            <Typography variant="body2">
                                                                {matchedPeriod?.courseSessionName}
                                                            </Typography>
                                                            {getStatusChip(matchedPeriod?.substituteName)}
                                                        </>
                                                    ) : (
                                                        <Typography variant='body2' sx={{ color: 'warning.main', fontWeight: 500 }}>
                                                            No Course
                                                        </Typography>
                                                    )
                                                    }
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                ) : (
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={(periods?.length ?? 0) + 1} sx={cellSx}>
                                <Box sx={outerBoxSx}>
                                    <Box sx={staffPeriodBox}>
                                        <NoRecords
                                            message="No Coverage Needed"
                                        />
                                    </Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                )}
            </Table>
        </TableContainer>
    );
}

export default SubstituteTableList;